module.exports = __webpack_public_path__ + "static/media/cute-cat.84444b11.png";